var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 5,
    viewBox: "0 0 351 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1403_1373)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 181.11,
    y1: -0.288162,
    x2: 174.753,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.577,
    y1: -0.288162,
    x2: 178.22,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.044,
    y1: -0.288162,
    x2: 181.687,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.511,
    y1: -0.288162,
    x2: 185.155,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.978,
    y1: -0.288162,
    x2: 188.622,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.445,
    y1: -0.288162,
    x2: 192.089,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.913,
    y1: -0.288162,
    x2: 195.556,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.38,
    y1: -0.288162,
    x2: 199.023,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.847,
    y1: -0.288162,
    x2: 202.491,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.314,
    y1: -0.288162,
    x2: 205.958,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.782,
    y1: -0.288162,
    x2: 209.425,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 219.249,
    y1: -0.288162,
    x2: 212.892,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.716,
    y1: -0.288162,
    x2: 216.359,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.183,
    y1: -0.288162,
    x2: 219.827,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.651,
    y1: -0.288162,
    x2: 223.294,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.118,
    y1: -0.288162,
    x2: 226.761,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.585,
    y1: -0.288162,
    x2: 230.228,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.052,
    y1: -0.288162,
    x2: 233.696,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.519,
    y1: -0.288162,
    x2: 237.163,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.986,
    y1: -0.288162,
    x2: 240.63,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.454,
    y1: -0.288162,
    x2: 244.097,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 253.921,
    y1: -0.288162,
    x2: 247.565,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.388,
    y1: -0.288162,
    x2: 251.032,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.855,
    y1: -0.288162,
    x2: 254.499,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.323,
    y1: -0.288162,
    x2: 257.966,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.79,
    y1: -0.288162,
    x2: 261.433,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.257,
    y1: -0.288162,
    x2: 264.9,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.724,
    y1: -0.288162,
    x2: 268.368,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 278.191,
    y1: -0.288162,
    x2: 271.835,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.659,
    y1: -0.288162,
    x2: 275.302,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 285.126,
    y1: -0.288162,
    x2: 278.769,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.593,
    y1: -0.288162,
    x2: 282.237,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.06,
    y1: -0.288162,
    x2: 285.704,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.528,
    y1: -0.288162,
    x2: 289.171,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.577869,
    x2: 8.98953,
    y2: -0.577869,
    transform: "matrix(-0.707108 0.707106 -0.707108 -0.707106 298.586 -0.696777)",
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.577869,
    x2: 8.98953,
    y2: -0.577869,
    transform: "matrix(-0.707108 0.707106 -0.707108 -0.707106 302.053 -0.696777)",
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 305.929,
    y1: -0.288162,
    x2: 299.573,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.396,
    y1: -0.288162,
    x2: 303.04,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.864,
    y1: -0.288162,
    x2: 306.507,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.331,
    y1: -0.288162,
    x2: 309.974,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 319.798,
    y1: -0.288162,
    x2: 313.441,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 323.265,
    y1: -0.288162,
    x2: 316.909,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 326.732,
    y1: -0.288162,
    x2: 320.376,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.2,
    y1: -0.288162,
    x2: 323.843,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.667,
    y1: -0.288162,
    x2: 327.31,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.134,
    y1: -0.288162,
    x2: 330.778,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340.601,
    y1: -0.288162,
    x2: 334.245,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.069,
    y1: -0.288162,
    x2: 337.712,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.536,
    y1: -0.288162,
    x2: 341.179,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.003,
    y1: -0.288162,
    x2: 344.646,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 354.47,
    y1: -0.288162,
    x2: 348.114,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.814377,
    y1: -0.288162,
    x2: -5.54218,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.28166,
    y1: -0.288162,
    x2: -2.0749,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.74882,
    y1: -0.288162,
    x2: 1.39227,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.2161,
    y1: -0.288162,
    x2: 4.85955,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.6833,
    y1: -0.288162,
    x2: 8.32672,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.1504,
    y1: -0.288162,
    x2: 11.7939,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.6177,
    y1: -0.288162,
    x2: 15.2612,
    y2: 6.0684,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.0849,
    y1: -0.288162,
    x2: 18.7283,
    y2: 6.0684,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.5522,
    y1: -0.288162,
    x2: 22.1956,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.0193,
    y1: -0.288162,
    x2: 25.6628,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.4865,
    y1: -0.288162,
    x2: 29.1299,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.9538,
    y1: -0.288162,
    x2: 32.5972,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.4209,
    y1: -0.288162,
    x2: 36.0644,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.8882,
    y1: -0.288162,
    x2: 39.5317,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.3554,
    y1: -0.288162,
    x2: 42.9988,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.8227,
    y1: -0.288162,
    x2: 46.4661,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.2898,
    y1: -0.288162,
    x2: 49.9333,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.757,
    y1: -0.288162,
    x2: 53.4004,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.2243,
    y1: -0.288162,
    x2: 56.8677,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.6915,
    y1: -0.288162,
    x2: 60.3349,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.1587,
    y1: -0.288162,
    x2: 63.8022,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.6259,
    y1: -0.288162,
    x2: 67.2693,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.0932,
    y1: -0.288162,
    x2: 70.7366,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.5602,
    y1: -0.288162,
    x2: 74.2037,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.0275,
    y1: -0.288162,
    x2: 77.671,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.4948,
    y1: -0.288162,
    x2: 81.1382,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.9618,
    y1: -0.288162,
    x2: 84.6053,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.4291,
    y1: -0.288162,
    x2: 88.0726,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.8964,
    y1: -0.288162,
    x2: 91.5398,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.364,
    y1: -0.288162,
    x2: 95.0071,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.831,
    y1: -0.288162,
    x2: 98.4742,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.298,
    y1: -0.288162,
    x2: 101.941,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.765,
    y1: -0.288162,
    x2: 105.409,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.232,
    y1: -0.288162,
    x2: 108.876,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.7,
    y1: -0.288162,
    x2: 112.343,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.167,
    y1: -0.288162,
    x2: 115.81,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.634,
    y1: -0.288162,
    x2: 119.278,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.101,
    y1: -0.288162,
    x2: 122.745,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.569,
    y1: -0.288162,
    x2: 126.212,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.036,
    y1: -0.288162,
    x2: 129.679,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.503,
    y1: -0.288162,
    x2: 133.146,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.97,
    y1: -0.288162,
    x2: 136.614,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.437,
    y1: -0.288162,
    x2: 140.081,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.577869,
    x2: 8.98953,
    y2: -0.577869,
    transform: "matrix(-0.707106 0.707107 -0.707106 -0.707107 149.496 -0.696777)",
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.577869,
    x2: 8.98953,
    y2: -0.577869,
    transform: "matrix(-0.707106 0.707107 -0.707106 -0.707107 152.963 -0.696777)",
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.839,
    y1: -0.288162,
    x2: 150.482,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.306,
    y1: -0.288162,
    x2: 153.95,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.773,
    y1: -0.288162,
    x2: 157.417,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.241,
    y1: -0.288162,
    x2: 160.884,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170.708,
    y1: -0.288162,
    x2: 164.351,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.175,
    y1: -0.288162,
    x2: 167.819,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.642,
    y1: -0.288162,
    x2: 171.286,
    y2: 6.06839,
    stroke: "#337E93",
    strokeWidth: 1.15574
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1403_1373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 4,
    fill: "white",
    transform: "translate(0.5 0.458984)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarFooter);
export default __webpack_public_path__ + "static/media/barFooter.b81b9e1f1afe18664ac8fe59931ed8a1.svg";
export { ForwardRef as ReactComponent };